module.exports = __webpack_public_path__ + "0916ee8108520aed98060f4a4793af47.png";